module.exports = __webpack_public_path__ + "static/media/top_logo_shape.fc702aff.png";